import OLXAd from "./OLXAd";

export default OLXAd;